<template>
    <div class="app-comment-list">
        <app-loading v-if="loading"/>
        <template v-show="!loading" v-for="item in list">
            <comment-item :key="item.id"
                          :data="item"
                          @comment-success="handleCommentSuccess"
            />
        </template>
    </div>
</template>

<script>
    import CommentItem from './CommentItem'

    import getCommentListService from '@service/getCommentListService'
    import AppLoading from "@components/AppLoading";

    export default {
        name: "AppCommentList",
        props: {
            hostId: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                loading: false,
                list: []
            }
        },
        watch: {
            hostId: {
                handler(val) {
                    if (val) {
                        this.getCommentList(val)
                    }
                },
                immediate: true
            }
        },
        methods: {
            async getCommentList(hostId) {
                try {
                    this.loading = true
                    const {data, total} = await getCommentListService({hostId})
                    this.list = data
                    this.$emit('get-success', {
                        data,
                        total
                    })
                } catch (e) {
                    console.log(e)
                } finally {
                    this.loading = false
                }
            },
            handleCommentSuccess() {
                this.$emit('comment-success')
            },
            refresh() {
                const {hostId} = this
                if (hostId) {
                    this.getCommentList(hostId)
                }
            }
        },
        components: {
            AppLoading,
            CommentItem
        }
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";
    @import "@assets/styles/mixins.scss";

    .app-comment-list {
        position: relative;
    }
</style>